module.exports = __webpack_public_path__ + "img/Group6.854b27b8.png";